<template>
  <div v-loading="loading" class="shop-usage-summary">
    <p v-for="item in summaryItems" :key="item.key" class="summary-item">
      {{ $t(`homePage.usageSummary.${item.key}`) }}：{{ item.value }}
    </p>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'
import { useShopHomePageSummary } from '@/use/useShopHomePageSummary'

export default defineComponent({
  name: 'ShopUsageSummary',
  setup () {
    const { summaryItems, loading, getSummary } = useShopHomePageSummary()

    onMounted(getSummary)

    return { summaryItems, loading }
  },
})
</script>

<style lang="postcss" scoped>
.shop-usage-summary {
  @apply flex flex-col gap-[4px];
}
</style>
